import { Locale } from '@ps-smart-cp/ppfw-client';
import { rawValueToEnum } from '../utils';

/** カスタムフィールドの長さ属性 */
enum CustomFieldLength {
  fixedLength = '1',
  variableLength = '2',
}

const nameConfig = {
  fixedLength: new Map([[Locale.ja, '固定長']]),
  variableLength: new Map([[Locale.ja, '可変長']]),
};

const toEnum = rawValueToEnum(CustomFieldLength, '');

export const customFieldLength = {
  enum: CustomFieldLength,
  nameConfig,
  toEnum,
};
export type { CustomFieldLength };
